import * as LeadGrid from '../../Services/LeadGridCms'
import * as Notification from '../../Services/Notification'
import * as Actions from '../CmsActions'

export const load = (id: number) => async (dispatch, getState) => {
  const services = await LeadGrid.allServices(id)

  if (!services.ok) {
    Notification.error('サービスの読み込みに失敗しました', '')
    return
  }

  dispatch(requestFetchService(services))
}

export const requestFetchService = (services) => ({
  type: Actions.SUCCESS_FETCH_SERVICES,
  payload: { services: services.data },
})
